import { Outlet } from 'react-router-dom'
import { useLayoutEffect } from 'react'
import { PageLayout } from '../../../components/PageLayout'
import { useGetRecommendedUsersForMyProjectsQuery, useGetRecommendationsSummaryQuery } from '../../../api/recommendations'
import { RecommendationsTabs } from './RecommendationsTabs'
import { useProfileGate } from '../../../hooks/useProfileGate'

export const RecommendationsLayout = () => {
  useLayoutEffect(() => {
    document.title = 'Рекомендации'
  }, [])

  const { isProfileReady } = useProfileGate()
  const { data: summary, isLoading, isError } = useGetRecommendationsSummaryQuery(undefined, {
    skip: !isProfileReady,
  })
  const { data: myProjectsRecommendations, isError: isMyProjectsError } = useGetRecommendedUsersForMyProjectsQuery({ limit: 20 }, {
    skip: !isProfileReady,
  })

  const myProjectsMatches = [
    ...(myProjectsRecommendations?.exact ?? []),
    ...(myProjectsRecommendations?.potential ?? []),
  ]
  const myProjectsDerivedCounts = !isMyProjectsError && myProjectsRecommendations
    ? {
        for_my_projects: myProjectsMatches.filter((match) => match.slot.kind !== 'resource').length,
        for_resources: myProjectsMatches.filter((match) => match.slot.kind === 'resource').length,
      }
    : null
  const counts = !isLoading && !isError
    ? {
        for_me: summary?.tabs.for_me ?? 0,
        for_my_projects: myProjectsDerivedCounts?.for_my_projects ?? summary?.tabs.for_my_projects ?? 0,
        for_resources: myProjectsDerivedCounts?.for_resources ?? summary?.tabs.for_resources ?? 0,
        for_my_teams: summary?.tabs.for_my_teams ?? 0,
      }
    : undefined

  return <PageLayout title="Рекомендации" topComponent={<RecommendationsTabs counts={counts} />} mainComponent={<Outlet />} />
}
